import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Grid } from 'semantic-ui-react';

import Slider, { createSliderWithTooltip } from 'rc-slider';

const SliderTooltip = createSliderWithTooltip(Slider);

class StakeSlider extends Component {
  static propTypes = {
    balance: PropTypes.number.isRequired,
    stake: PropTypes.number.isRequired
  };

  state = {
    stake: this.props.stake
  };

  onStakeChange = value => {
    this.props.handleStakeChange(value);
    this.setState({
      stake: value
    });
  };

  onInputChange = (e, { value }) => {
    this.onStakeChange(Number(value));
  };

  setMax = () => {
    this.onStakeChange(this.props.balance);
  };

  render() {
    const { balance } = this.props;

    return (
      <Grid columns="equal" id="stake-slider">
        <Grid.Column width={12}>
          <label className="title">Stake Amount</label>
          <div className="sub-label">How much is on the table?</div>
          <SliderTooltip value={this.state.stake} min={5} step={5} max={balance} onChange={this.onStakeChange} />
        </Grid.Column>
        <Grid.Column>
          <Input
            size="mini"
            type="number"
            min={1}
            max={balance}
            value={this.state.stake}
            onChange={this.onInputChange}
          />
          <span onClick={this.setMax} title="Go all in">Max stake</span>
        </Grid.Column>
      </Grid>
    );
  }
}

export default StakeSlider;



// WEBPACK FOOTER //
// ./src/App/CreateStake/StakeSlider.js